var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_286",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 286",
    transform: "translate(9.15 -589.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_288",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 288",
    width: 39,
    height: 39,
    transform: "translate(-9.15 589.85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar-blank_1_",
    "data-name": "calendar-blank (1)",
    transform: "translate(-5.339 593.661)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_287",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 287",
    width: 31.508,
    height: 31.508,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    d: "M-6.008-8H13.913a1.994,1.994,0,0,1,1.992,1.992V13.913a1.994,1.994,0,0,1-1.992,1.992H-6.008A1.994,1.994,0,0,1-8,13.913V-6.008A1.994,1.994,0,0,1-6.008-8ZM13.913,13.913V-6.008H-6.009V13.913Z",
    transform: "translate(11.801 11.801)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    d: "M-7.05-2.3A.95.95,0,0,1-8-3.248v-3.8A.95.95,0,0,1-7.05-8a.95.95,0,0,1,.95.95v3.8A.95.95,0,0,1-7.05-2.3Z",
    transform: "translate(28.725 9.901)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    d: "M-7.05-2.3A.95.95,0,0,1-8-3.248v-3.8A.95.95,0,0,1-7.05-8a.95.95,0,0,1,.95.95v3.8A.95.95,0,0,1-7.05-2.3Z",
    transform: "translate(16.882 9.901)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    "data-name": "Line 21",
    d: "M14.909-6.1H-7a.974.974,0,0,1-1-.95A.974.974,0,0,1-7-8H14.909a.974.974,0,0,1,1,.95A.974.974,0,0,1,14.909-6.1Z",
    transform: "translate(11.801 17.869)",
    fill: "#242323"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar_black.49b99d171293548d84f5bcdc3bbb571f.svg";
export { ForwardRef as ReactComponent };